<template>
  <a-modal v-model:visible="computedShowModal"
           width="600px"
           :closable="false"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
  >
    <div class="modal-content-body">
      <div class="search-client-header">
        <div class="modal-title">
          {{ modalType === 'MANAGER' ? '담당자 검색' : '거래처 검색' }}
        </div>
        <button
            type="button"
            class="btn-close"
            @click="uiHandler.closeModal"
        >
          <i class="fa-regular fa-x"/>
        </button>
      </div>
      <div class="search-client-content d-flex justify-content-center flex-column align-items-center">
        <div class="search-input-container">
          <i class="fa-solid fa-magnifying-glass"/>
          <input
              type="text"
              @keyup.enter="uiHandler.search"
              v-model="searchParam.condition"
              placeholder="거래처 이름 또는 대표자명 또는 사업자번호를 입력해주세요."
          >
          <button class="search" @click="uiHandler.search">검색</button>
        </div>
        <div class="list-container">
          <div class="list-items" v-if="result.list.length > 0">
            <div
                v-for="(item, index) in result.list"
                class="list-item"
                :class="item.isSelected ? 'selected' : ''"
                @click="uiHandler.chooseItem(index)"
            >
              <a-typography-text :ellipsis="true" style="width: 100%;">
                <div class="item-left">
                  {{ item.name }}<span class="cno">({{ item.convertedHospitalInfo }})</span>
                </div>
              </a-typography-text>
              <div class="item-right" v-if="item.isSelected">
                <i class="fa-solid fa-check"/>
              </div>
            </div>
          </div>
          <div
              v-else
              style="
                align-items: center;
                justify-content: center;
                display: flex;
                margin-top: 164px;"
          >
            <no-result
                :colspan="10"
                :message="computedNoResultMessage"
                :height="'auto'"
                :noIcon="true"
            />
          </div>
        </div>
        
        <div class="pagination-container">
          <div
              v-if="$store.state.isLoading !== false || result.list.length === 0"
              class="page-wrapper"
          />
          <pagination
              v-if="$store.state.isLoading === false && result.list.length > 0"
              :page-info="paginationData"
              page-name="SearchClientModal"
              :pagePerBlock="5"
              @change-page="uiHandler.paginationHandler"
          />
        </div>
        
        <div class="modal-footer-actions">
          <button
              class="contract-cancel-btn btn-hover"
              @click="uiHandler.closeModal"
          >
            취소
          </button>
          <button
              class="contract-submit-btn btn-hover yellow-button"
              @click="uiHandler.emitClient"
          >
            {{ modalType === 'MANAGER' ? '선택한 거래처의 담당자 적용하기' : '선택한 거래처 적용하기' }}
          </button>
        </div>
      </div>
    </div>
    <div class="expiration-modal-footer" style="display: none;">
      <button
          class="contract-cancel-btn btn-hover"
          @click="uiHandler.closeModal"
      >
        취소
      </button>
      <button
          class="contract-submit-btn btn-hover yellow-button"
          @click="uiHandler.emitClient"
      >
        선택한 거래처 적용하기
      </button>
    </div>
  </a-modal>
</template>
<script>
import {
  businessNumberFormatter, 
} from '@/utils/utils';
import NoResult from '@/views/components/NoResult';
import Pagination from '@/views/components/Pagination';
import salesRecordsApis from '../api';

export default {
  components: {
    Pagination,
    NoResult,
  },
  emits: ['update:visible', 'select-client', 'close-modal'],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    initDataLoad: {
      type: Boolean,
      required: false,
      default: true
    },
    searchType: {
      type: String,
      required: false,
      default: 'HOSPITAL'
    },
    modalType: {
      type: String,
      required: false,
      default: 'CLIENT'
    }
  },
  computed: {
    computedShowModal: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    computedNoResultMessage() {
      return '검색 결과가 없습니다.';
    },
    formToParam() {
      const {searchParam} = this
      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = 10;
      obj.type = this.searchType;
      
      if (searchParam?.condition) {
        if (typeof searchParam.condition === "string") {
          obj.search = 'name'
        }
        if (typeof searchParam.condition === "number") {
          obj.search = 'cNo'
        }
        obj.condition = searchParam.condition;
      }
      return obj
    }
  },
  data() {
    return {
      businessNumberFormatter,
      uiHandler: this.ui(),
      apiHandler: this.api(),
      searchParam: {
        search: '', // 숫자일때: cNo(사업자 번호), 문자일때: name(병원명)
        condition: '',
      },
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
      },
      selectedItem: {},
      result: {
        list: [],
        totalDocs: 0,
      },
    }
  },
  mounted() {
    if (this.initDataLoad) {
      this.uiHandler.getClientList()
    }
  },
  watch: {
    visible(newVal) {
      if (newVal === true) {
        // 모달이 열릴 때 거래처 목록 검색
        this.searchParam.condition = '';
        this.paginationData.currentPage = 1;
        this.uiHandler.getClientList();
      }
    }
  },
  methods: {
    ui() {
      const paginationHandler = async (childPassParam) => {
        this.paginationData.currentPage = childPassParam.page;
        await this.uiHandler.getClientList();
      }
      
      const joinHospitalInfo = (item) => {
        const array = [
          item.ceo,
          businessNumberFormatter(item.cNo),
        ];

        let address = '';
        if (item.bizAddr) {
          address = item.bizAddr;
        } else if (item.addrOne && item.addrTwo && item.addrThree) {
          address = `${item.addrOne} ${item.addrTwo} ${item.addrThree}`;
        }

        if (item.addrDetail) address += ` ${item.addrDetail}`;

        if (address) array.push(address)

        return array.join(', ');
      }

      const chooseItem = (index) => {
        if (this.result.list[index].isSelected) return;
        this.result.list.forEach((item, i) => {
          if (index !== i) item.isSelected = false;
        });
        this.result.list[index].isSelected = true;
        this.selectedItem = this.result.list[index];
      }
      
      const search = async () => {
        this.paginationData.currentPage = 1;
        await this.uiHandler.getClientList();
      }
      
      const validateData = async () => {
        const selectedItem = this.selectedItem;
        if (!selectedItem.isSelected) {
          this.$message.warning('거래처를 선택해 주세요.');
          return {status: false};
        }

        return {status: true, selectedItem};
      }
      
      return {
        getClientList: async () => {
          await this.apiHandler.getClientList(this.formToParam, (response) => {
            if (response.data.message) {
              this.$message.warning('검색어에 특수문자를 포함할 수 없습니다.');
              return;
            }

            this.result.list = response.data.docs;
            this.result.totalDocs = response.data.totalDocs;
            this.paginationData.totalPages = response.data.totalPages;
            
            for (let i = 0; i < this.result.list.length; i++) {
              const item = this.result.list[i];
              item.convertedHospitalInfo = joinHospitalInfo(item);
              item.isSelected = false;
            }
          }, (error) => {
            console.error('거래처 목록 조회 실패:', error);
            this.$message.error('거래처 목록을 불러오는 중 오류가 발생했습니다.');
          })
        },
        chooseItem,
        paginationHandler,
        emitClient: async () => {
          const result = await validateData();
          if (!result.status) return;
          this.$emit('select-client', result.selectedItem);
          this.computedShowModal = false;
        },
        search,
        closeModal: () => {
          this.$emit('close-modal');
          this.computedShowModal = false;
        }
      }
    },
    api() {
      return salesRecordsApis(this.$apiInstance, this.$store);
    }
  }
}
</script>
<style scoped lang="scss">
.modal-content-body {
  padding: 16px;
  position: relative;
  height: 840px;
  display: flex;
  flex-direction: column;
}

.search-client-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-client-content {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.modal-title {
  font-size: 18px;
  font-weight: bold;
}

.btn-close {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.search-input-container {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  
  i {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
  }
  
  input {
    width: 100%;
    height: 40px;
    padding: 8px 110px 8px 38px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #f9fafb;
    
    &:focus {
      outline: none;
      border-color: #FFCC32;
    }
  }
  
  button.search {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #FFCC32;
    color: #000;
    border: none;
    border-radius: 4px;
    padding: 6px 15px;
    cursor: pointer;
    font-weight: 500;
    
    &:hover {
      background-color: #E6B82E;
    }
  }
}

.list-container {
  width: 100%;
  height: 448px;
  overflow-y: auto;
  margin-bottom: 12px;
}

.list-items {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.list-item {
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &.selected {
    background-color: #FFCC32;
  }
}

.item-left {
  font-weight: 500;
  
  .cno {
    font-weight: normal;
    color: #666;
    margin-left: 8px;
    font-size: 0.9em;
  }
}

.item-right {
  color: #fff;
}

.page-wrapper {
  height: 40px;
  margin-top: 16px;
}

.pagination-container {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 16px;
}

.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 0 0;
  width: 100%;
  border-top: 1px solid #f0f0f0;
}

.expiration-modal-footer {
  display: none;
}

.contract-cancel-btn {
  padding: 6px 16px;
  background-color: #f0f0f0;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  
  &:hover {
    background-color: #e0e0e0;
  }
}

.contract-submit-btn {
  padding: 6px 16px;
  background-color: #FFCC32;
  border: 1px solid #FFCC32;
  border-radius: 4px;
  color: #000;
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    background-color: #E6B82E;
    border-color: #E6B82E;
  }
}

.yellow-button {
  background-color: #FFCC32 !important;
  border-color: #FFCC32 !important;
  color: #000 !important;
  
  &:hover {
    background-color: #E6B82E !important;
    border-color: #E6B82E !important;
  }
  
  &:disabled {
    background-color: #d9d9d9 !important;
    border-color: #d9d9d9 !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }
}
</style>
